import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { generateTemplate } from "configs/utils/Excel";

export const getAllBobotPenilaian = createAsyncThunk("bobotPenilaian/getAllBobotPenilaian", 
    async({ page, pageSize, search }, { rejectWithValue }) => {
        try{
            const token = localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const searchParams = search === undefined ? "" : search;
            const url = `v1/bobot/penilaian/pageable?page=${page}&size=${pageSize}&search=${searchParams}`
            const { data } = await jwtAuthAxios.get(url)
            const { result, page: pageResult } = data?.data;
            const { number, size, totalElements, totalPages  } = pageResult;
            return {
                result,
                number,
                size,
                totalElements,
                totalPages   
            };
        } catch(err){
            rejectWithValue(err?.response?.data?.message || 'error')
        }
    }
);


export const getBobotPenilaianByIdProdi = createAsyncThunk("bobotPenilaian/getBobotPenilaianByIdProdi",
    async(id, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const { data } = await jwtAuthAxios.get(`v1/bobot/penilaian/prodi/${id}`);
            const {
                id_prodi,
                nama_prodi: prodi,
                ...rest
            } = data;


            const nama_prodi = JSON.stringify({
                id_program_studi: id_prodi,
                nama_program_studi: prodi
            });

            return {
                nama_prodi,
                ...rest
            };
        } catch(err){
            rejectWithValue(err?.response?.data?.message || 'error')
        }
    }
);

export const getBobotPenilaianById = createAsyncThunk("bobotPenilaian/getBobotPenilaianById", 
    async(id, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const { data } = await jwtAuthAxios.get(`v1/bobot/penilaian/${id}`);
            const { 
                id_prodi, 
                nama_prodi: prodi,
                ...rest 
            } = data;


            const nama_prodi = JSON.stringify({ 
                id_program_studi: id_prodi, 
                nama_program_studi: prodi
            });

            return {
                nama_prodi,
                ...rest
            };
        } catch(err){
            rejectWithValue(err?.response?.data?.message || 'error')
        }
    }
);

export const addBobotPenilaian = createAsyncThunk("bobotPenilaian/addBobotPenilaian", 
    async(payload, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const { data } = await jwtAuthAxios.post('v1/bobot/penilaian', payload);
            const { result } = data?.data;
            return {
                result  
            };
        } catch(err){
            rejectWithValue(err?.response?.data?.message || 'error')
        }
    }
);

export const updateBobotPenilaian = createAsyncThunk("bobotPenilaian/updateBobotPenilaian", 
    async(payload, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const { data } = await jwtAuthAxios.put('v1/bobot/penilaian',payload);
            const { result } = data?.data;
            return {
                result  
            };
        } catch(err){
            rejectWithValue(err?.response?.data?.message || 'error')
        }   
    }
);

export const deleteBobotPenilaian = createAsyncThunk("bobotPenilaian/deleteBobotPenilaian", 
    async(id, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            await jwtAuthAxios.delete(`v1/bobot/penilaian/${id}`);
            return id;
        } catch(err){
            rejectWithValue(err?.response?.data?.message || 'error')
        } 
    }
);

export const downloadTemplateExcel = createAsyncThunk("bobotPenilaian/downloadTemplateExcel",
	async (payload, { rejectWithValue }) => {
		try {
			const workbook = await generateTemplate(payload);

			// Save to blob
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { 
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
			});
            const url = URL.createObjectURL(blob);

            // Create a temporary link element
            const link = document.createElement('a');
            link.href = url;
            link.download = 'bobot_penilaian_data.xlsx';

            // Trigger a click on the link to initiate the download
            link.click();

            // Cleanup
            URL.revokeObjectURL(url);
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

const bobotPenilaian = {
    nama_prodi: '',
    kehadiran: '',
    tugas: '',
    uts: '',
    uas: ''
};

const pagination = {
	page: 1,
	pageSize: 10,
	pageSizeOptions: ['10', '20', '30', '50'],
	total: 0,
}

const initialState = {
    dataAll: [],
    bobotPenilaianId: {
        ...bobotPenilaian
    },
	loading: false,
	pagination: {
		dataAll: { ...pagination }
	}
}

const bobotPenilainSlice = createSlice({
    name:"bobotPenilaian",
    initialState,
    reducers: {
        onRefreshForm: (state) => {
			state.bobotPenilaianId = initialState.bobotPenilaianId
			state.loading = initialState.loading;
		},
		onRefreshLoading: (state) => {
			state.loading = initialState.loading;
		},
		onChangeData: (state, action) => ({
			...state,
			...action.payload
		}),
		onChangePagination: (state, action) => {
			const { paginationName, pageChange, pageSizeChange, totalChange } = action.payload;
			state.pagination[paginationName] = {
				...state.pagination[paginationName],
				page: state.pagination[paginationName].pageSize !== pageSizeChange ? 1 : pageChange,
				pageSize: pageSizeChange,
				total: totalChange,
			}
		},
    },
    extraReducers: (builder) => {
    builder
        .addCase(getAllBobotPenilaian.pending, (state) => {
            state.loading = true;
        })
        .addCase(getAllBobotPenilaian.fulfilled, (state, action) => {
            const { result, number, size, totalElements } = action.payload;
            state.dataAll = result;
            state.pagination.dataAll = {
                ...state.pagination.dataAll,
                page: state.pagination.dataAll.pageSize !== size ? 1 : number + 1,
                pageSize: size,
                total: totalElements,
            }
            state.loading = false;
        })
        .addCase(getAllBobotPenilaian.rejected, (state) => {
            state.loading = false;
        })

    builder
        .addCase(getBobotPenilaianById.pending, (state) => {
            state.loading = true;
        })
        .addCase(getBobotPenilaianById.fulfilled, (state, action) => {
            const { 
                nama_prodi,
                ...rest 
            } = action.payload;
            
            state.bobotPenilaianId = {
                ...state.bobotPenilaianId,
                nama_prodi,
                ...rest
            };
            
            state.loading = false;
        })
        .addCase(getBobotPenilaianById.rejected, (state) => {
            state.loading = false;
        })

    builder
        .addCase(getBobotPenilaianByIdProdi.pending, (state) => {
            state.loading = true;
        })
        .addCase(getBobotPenilaianByIdProdi.fulfilled, (state, action) => {
            const {
                nama_prodi,
                ...rest
            } = action.payload;

            state.bobotPenilaianId = {
                ...state.bobotPenilaianId,
                nama_prodi,
                ...rest
            };

            state.loading = false;
        })
        .addCase(getBobotPenilaianByIdProdi.rejected, (state) => {
            state.loading = false;
        })

    builder
        .addCase(deleteBobotPenilaian.pending, (state) => {
            state.loading = true;
        })
        .addCase(deleteBobotPenilaian.fulfilled, (state) => {
            state.loading = false;
        })
        .addCase(deleteBobotPenilaian.rejected, (state) => {
            state.loading = false;
        })
        
    builder
        .addCase(addBobotPenilaian.pending, (state) => {
            state.loading = true;
        })
        .addCase(addBobotPenilaian.fulfilled, (state) => {
            state.loading = false;
        })
        .addCase(addBobotPenilaian.rejected, (state) => {
            state.loading = false;
        })

    builder
        .addCase(updateBobotPenilaian.pending, (state) => {
            state.loading = true;
        })
        .addCase(updateBobotPenilaian.fulfilled, (state) => {
            state.loading = false;
        })
        .addCase(updateBobotPenilaian.rejected, (state) => {
            state.loading = false;
        })
    }
})

export const {
    onRefreshForm,
	onRefreshLoading,
	onChangeData,
	onChangePagination,
} = bobotPenilainSlice.actions

export const selectBobotPenilaian = (state) => state.bobotPenilaian;
export default bobotPenilainSlice.reducer;